import {Component, OnInit, HostListener, Input} from '@angular/core';
import { ViewportScroller} from '@angular/common';
import * as $ from "jquery";
import 'jquery';
import '../../../../assets/js/material-kit';
import '../../../../assets/js/jquery';
import '../../../../assets/js/nicepage';

import {NavigatorService} from "../../../services/navigatorService/navigator.service";
import {UserService} from "../../../services/api-handlers/userService/user.service";
import {BootstrapNotifyService} from "../../../services/bootstrap-notify/bootstrap-notify.service";
import {CacheService} from "../../../services/cacheService/cache.service";
import {SharedFormService} from "../../../services/shared-form.service";
import {Router} from "@angular/router";
import {IResponse} from "../../../interfaces/iresponse";

@Component({
  selector: 'app-preview-page',
  templateUrl: './preview-page.component.html',
  styleUrls: ['./preview-page.component.css']
})
export class PreviewPageComponent implements OnInit {
  public credentials: any;
  public schools: any;
  // @Input editState: false;

  pageYoffset = 0;
  public loading = false;
  public year: number = new Date().getFullYear();

  loaders = {
    loading: false
  };

  @HostListener('window:scroll', ['$event']) onScroll(event){
    this.pageYoffset = window.pageYOffset;
  }
  constructor(private userService: UserService, private cacheService: CacheService,
              private bootstrapService: BootstrapNotifyService, private scroll: ViewportScroller, private navigationService: NavigatorService, private sharedFormService: SharedFormService, private route: Router) { }


  scrollToContact() {

    if ($('.section-contact-us').length != 0) {
      $("html, body").animate({
        scrollTop: $('.section-contact-us').offset().top
      }, 1000);
    }
  };

  ngOnInit(): void {
    this.getSchools();
    console.log('Preview Page Message', this.sharedFormService.admissionData);
    // this.credentials = this.sharedFormService.admissionData;
    this.credentials = JSON.parse(localStorage.getItem('LoginCredentials'));
  }

  scrollToTop(){
    this.scroll.scrollToPosition([0,0]);
  }

  public goBackToAdmissionsPage() {
    this.loaders.loading = true;
    // console.log('Preview Page EDITS', this.credentials);
    this.route.navigate(['/online-admissions', {type: 'type'}]);
    // this.navigationService.navigateUrl('/online-admissions');
    this.loaders.loading = false;
  }

  public goToPaymentsPage() {
    this.loaders.loading = true;
    // this.sharedFormService.admissionData = this.credentials;
    // console.log('Online admission Message', this.credentials);
    /*this.userService.signUp(this.credentials).subscribe((res: any) => {
      console.log('Signup Full Data', this.credentials);
      this.bootstrapService.success(res?.description, res?.code);
      this.route.navigate[('/online-admissions/payment')];
    }, error => {
      console.info('Error with Sign Up Form ', error);
      this.bootstrapService.error(error.error.message || 'Unable to Process Admission');
      // this.bootstrapService.error(error.error.description, error.error.code);
      this.loaders.loading = false;
    });*/
    this.navigationService.navigateUrl('/online-admissions/payment');
    this.loaders.loading = false;
    // this.router.navigate(["/online-admissions/preview"]);
  }

  public getSchools(): void {
    this.userService.getSchools().subscribe((response: IResponse) => {
      this.schools =  response.result;
    }, error => {
      this.bootstrapService.error(error?.error?.description, error?.error?.code);
    });
  }

  getObjectById(schoolId, array){
    if(array) {
      const arr = array.find((arr)=> {
        return arr.schoolId == schoolId;
      });
      if(arr){
        return arr
      }
    }
  }
}
